import { render, staticRenderFns } from "./createGift.vue?vue&type=template&id=297cd0b8&scoped=true"
import script from "./createGift.vue?vue&type=script&lang=js"
export * from "./createGift.vue?vue&type=script&lang=js"
import style0 from "./createGift.vue?vue&type=style&index=0&id=297cd0b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297cd0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297cd0b8')) {
      api.createRecord('297cd0b8', component.options)
    } else {
      api.reload('297cd0b8', component.options)
    }
    module.hot.accept("./createGift.vue?vue&type=template&id=297cd0b8&scoped=true", function () {
      api.rerender('297cd0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/fullGift/createGift.vue"
export default component.exports